<template>
    <td-dialog
        :title="$t(title)"
        @cancel="logDialogClose"
        :before-close="logDialogClose"
        :visible.sync="dialogUseDefineVisible"
        width="480px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <div>
            操作类型标签用于权限和操作日志注解，一个系统中标签唯一。<br />
            权限注解用于Control层接口上，操作日志注解用于Service层方法上。<br />
            <div style="background-color:#E1DFE1;word-wrap: break-word;">
                如Control层方法：<br />
                <div style="background-color:#00FF00;word-wrap: break-word;">@TDRequiresAllPermissions("operationType:{{ sPermission }}")<br /></div>
                public RestApiResultVo {{ sPermission }}(@RequestBody OperationTypeVo operationTypeVo) {<br />
                &nbsp&nbsp&nbsp&nbsp return typeService.{{ sPermission }}(operationTypeVo);<br />
                }<br />
            </div>
            其中：TDRequiresAllPermissions为权限标签，operationType为资源类型标签，{{ sPermission }}为操作类型标签；<br />
            接口加上这个权限注解，{{ sPermission }}这个接口需要用于有更新权限才能正常访问。<br /><br />
            <div style="background-color:#E1DFE1;word-wrap: break-word;">
                如Service层方法：<br />
                <div style="background-color:#00FF00;word-wrap: break-word;">@OperationLog(label = "operationType:{{ sPermission }}", object = "#{operationTypeVo}")<br /></div>
                public RestApiResultVo {{ sPermission }}(@RequestBody OperationTypeVo operationTypeVo) {<br />
                &nbsp&nbsp&nbsp&nbsp return typeDao.{{ sPermission }}(operationTypeVo);<br />
                }<br />
            </div>
            其中：OperationLog为日志注解，operationType为资源类型标签，{{ sPermission }}为操作类型标签,object为操作对象参数，没有时省略不写；<br />
            接口加上这个权限注解，{{ sPermission }}这个接口在访问成功时会自动记录操作日志，记录的日志可以在日志查询中查看。<br /><br />
        </div>
    </td-dialog>
</template>
<script>
export default {
    props: ['title', 'dialogUseDefineVisible', 'showItem'],
    created() {
        // 初始化数据
        this.initEditData();
    },
    // 定义变量
    data() {
        return {
            sPermission: 'edit'
        };
    },
    // 定义并实现方法体
    methods: {
        initEditData() {
            this.sPermission = this.showItem.sPermission;
        },
        // 关闭窗口之前需要调用的方法
        logDialogClose() {
            this.$emit('logDialogClose');
            this.$emit('submit');
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
